export const FORGOT = '/forgot';
export const LOGIN = '/login';
export const HOWTO = '/howto';
export const EARLY_ACCESS = '/early-access';
export const SIGNUP = '/signup';
// Rejestracja dedykowana ruchowi z Brand24 — osobny adres, żeby dało się ją linkować i mierzyć.
export const SIGNUP_BRAND24 = `${SIGNUP}/brand24`;
export const SET_PASSWORD = '/set-password/:hash';
export const QUESTIONS = '/questions';
export const TAGS = '/tags';
export const SUGGESTED_PROMPTS = '/suggested-prompts';
export const PRICING = '/pricing';
export const DAILY = '/daily';
export const ADD = '/add';
export const ALL = '/all';
export const QUEST = '/guest';
export const FAQ = '/faq';
export const QUEST_FAQ = `${QUEST}${FAQ}`;
export const PROJECTS = '/projects';
/** Cel linku z maila z zaproszeniem — przestawia aktywne konto na to, do którego zaproszono. */
export const INVITE_ACCEPT = '/invite/:accountId';
export const OVERVIEW = '/overview';
export const PROJECTS_PREVIEW = `${PROJECTS}/:id`;
export const PROJECTS_ADD = `${PROJECTS}${ADD}`;
export const QUESTIONS_ID = `${QUESTIONS}/:id`;
export const INTEGRATIONS = '/integrations';
export const DASHBOARD = '/dashboard';
export const LOGOUT = '/logout';
export const SETTINGS = '/settings';
export const MY_ACCOUNT = `${SETTINGS}/my-account`;
export const CHANGE_PASSWORD = `${SETTINGS}/change-password`;
export const BILLING_DATA = `${SETTINGS}/billing-data`;
export const SUBSCRIPTION = `${SETTINGS}/subscription`;
export const ORDERS = `${SETTINGS}/orders`;
export const TEAM = `${SETTINGS}/team`;
export const TEAM_ADD = `${TEAM}${ADD}`;
export const TEAM_PREVIEW = `${TEAM}/:id`;
export const PERIODIC_REPORTS = '/periodic-reports';
export const YOUR_ACCOUNTS = `${SETTINGS}/your-accounts`;
export const API_KEYS = `${SETTINGS}/api-keys`;
export const MARKETPLACE = '/marketplace';
export const ADMIN = '/admin';
export const USERS = '/users';
export const ACCOUNTS = '/accounts';
export const PERMISSIONS = '/permissions';
export const INTERCOM = '/intercom';
export const COSTS = '/costs';
export const CLI_COMMANDS = '/cli-commands';
export const REPORTS = '/reports';
export const EDIT = '/edit';
export const KEY_SOURCES_ANCHOR = '#key-sources';
export const KEY_PROMPTS_ANCHOR = '#key-prompts';
export const TRIAL_ENDED = '/trial-ended';
export const SOURCES = '/sources';
export const SOURCES_DOMAIN = '/sources/:projectId/domain/:domain/:period/:chat';
export const SOURCES_SOURCE = '/sources/:projectId/source/:sourceHash/:period/:chat';
export const INSIGHTS = '/insights';
export const CONTEXT_ANALYSIS = '/context-analysis';
export const KEYWORDS = '/keywords';
export const PROMPTS = '/prompts';
export const MAGIC_LOGIN = '/magic-login/:token';
export const SSO = '/sso';
export const GEO_CHECKLIST = '/geo-checklist';
export const AGENCY_STATS = '/agency-stats';
export const AGENCY_HUB = '/agency-hub';
/**
 * Query parameter the project wizard reads to know where "back" leads. Set by the Agency Hub's
 * "Add new project" (`?from=agency-hub`); absent = the projects list, as before.
 */
export const WIZARD_RETURN_PARAM = 'from';
export const WIZARD_RETURN_AGENCY_HUB = 'agency-hub';
export const AI_SIGNALS = '/ai-signals';
// Not '/ads': ad-blocker filter lists match URLs containing ad vocabulary (system-level blockers
// such as the AdGuard app filter page navigations too). Legacy '/ads/*' links redirect in AppRoutes.
export const ADS = '/paid-results';
export const AI_VISIBILITY_REPORT = '/ai-visibility-report';
export const PROMPT_ANALYST = '/prompt-analyst';
export const GEO_REPORT = '/geo-audit';
export const SOURCE_VERIFICATION = '/source-verification';
export const NOTIFICATIONS = '/notifications';
export const VERIFY_EMAIL = '/verify-email/:hash';
/** Ścieżka z maili wysłanych przed poprawką linku (wskazywała na endpoint backendu). */
export const VERIFY_EMAIL_LEGACY = '/auth/verify-email/:hash';
export const BOTS_ACTIVITY = '/bots-activity';
export const BOTS_ACTIVITY_PROJECT = (id: number | string): string => `/bots-activity/${id}`;
export const BOTS_ACTIVITY_ANALYSIS = (id: number | string): string =>
  `/bots-activity/${id}/analysis`;
export const BOTS_ACTIVITY_CONNECT = (id: number | string): string =>
  `/bots-activity/${id}/connect`;
export const BOT_ACCESS = '/bots-access';
export const BOT_ACCESS_PROJECT = (id: number | string): string => `/bots-access/${id}`;
export const AUTO_REACTIVATION = '/auto-reactivation';
export const SHARED_REPORT = '/shared-report';
export const SHARED_REPORT_TOKEN = `${SHARED_REPORT}/:token`;
export const PUBLIC_SCAN = '/ai-visibility-scan';
export const PUBLIC_SCAN_REPORT = `${PUBLIC_SCAN}/:token`;
